<template>
  <v-container fluid fill-height class="pa-0 ma-0 white" id="profile">
    <v-layout column class="pa-0 ma-0">
      <v-card-text>
        <h2 style="margin: 0% auto;"><b>Gapoktan</b></h2>
      </v-card-text>

      <v-card-text class="pa-0 margin-title">
        
        <v-card v-if="gapoktanLahanID">
          <gapoktan-list></gapoktan-list>
        </v-card>

        <v-card v-else>
          <gapoktan-list-two></gapoktan-list-two>
        </v-card>

      </v-card-text>

    </v-layout>
  </v-container>     
</template>

<script>
import { getUserById } from '@/api/user';

import VWidget from '@/components/VWidget';
import GapoktanList from '@/components/gapoktan/GapoktanList'
import GapoktanListTwo from '@/components/gapoktan/GapoktanListTwo'
import TambahkanGapoktan from '@/components/gapoktan/TambahkanGapoktan'
export default {
  components: {
    VWidget,
    GapoktanList,
    GapoktanListTwo,
    TambahkanGapoktan,
  },
  data () {
    return {
      chat: null,
      selectedTab: null,
      status: false,
      gapoktanLahanID: localStorage.gapoktanLahanID
    };
  },
  computed: {
   
    user () {
      let Origin = {
        name: 'Gapoktan',
        avatar: '',
      };
      let user = getUserById(this.$route.params.uuid);
      return Object.assign(Origin, user);
    }    
  },
};
</script>